import { Injectable } from '@angular/core';
import { CompanyPermissionsFactory } from '@shared/factories/company-permission/company-permissions.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class CompanyPermissionsResolver {
  constructor(
    private apiService: ApiServiceService,
    private companyPermissionsFactory: CompanyPermissionsFactory
  ) { }

  resolve() {
    const stored = this.companyPermissionsFactory.getPermissions();
    if (stored) return Promise.resolve(stored);
    return this.apiService.get('company/dashboard', 'security')
      .then((data: any) => {
        this.companyPermissionsFactory.savePermissions(data);
        return data;
      });
  }
}
